import { render, staticRenderFns } from "./report-status-admin.vue?vue&type=template&id=2d22e2d3&scoped=true"
import script from "./report-status-admin.vue?vue&type=script&lang=js"
export * from "./report-status-admin.vue?vue&type=script&lang=js"
import style0 from "./report-status-admin.vue?vue&type=style&index=0&id=2d22e2d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d22e2d3",
  null
  
)

export default component.exports